module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-10.e3533fc5.png";